var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".group-cls-1{fill:current;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "group-cls-1",
    d: "M32.34,37.34H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0H32.34a5,5,0,0,1,5,5V32.34A5,5,0,0,1,32.34,37.34ZM6,31.34H31.34V6H6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "group--cls-1",
    d: "M77,37.34H49.66a5,5,0,0,1-5-5V5a5,5,0,0,1,5-5H77a5,5,0,0,1,5,5V32.34A5,5,0,0,1,77,37.34Zm-26.34-6H76V6H50.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "group--cls-1",
    d: "M77,82H49.66a5,5,0,0,1-5-5V49.66a5,5,0,0,1,5-5H77a5,5,0,0,1,5,5V77A5,5,0,0,1,77,82ZM50.66,76H76V50.66H50.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "group-cls-1",
    d: "M32.34,82H5a5,5,0,0,1-5-5V49.66a5,5,0,0,1,5-5H32.34a5,5,0,0,1,5,5V77A5,5,0,0,1,32.34,82ZM6,76H31.34V50.66H6Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/group.2e922b6f.svg";
export { ForwardRef as ReactComponent };